import { Avatar, Box, Stack, Typography } from "@mui/material"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { red } from "@mui/material/colors"

interface DetailProductItem8Props {
  productImageUrl?: string | null
  productName?: string
  productDescription?: string
  value?: number | null
}

const DetailProductItem8 = ({
  productImageUrl,
  productName,
  productDescription,
  value,
}: DetailProductItem8Props) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignContent="center"
      alignItems="center"
      width="100%"
      sx={{ px: 1, py: 0.5 }}
    >
      <Box sx={{ height: 120, width: 120 }}>
        {productImageUrl && productImageUrl !== "" && (
          <img
            src={productImageUrl}
            alt={productName}
            style={{
              height: 120,
              width: 120,
              objectFit: "cover",
              borderRadius: "20px",
            }}
          />
        )}
      </Box>
      <Stack
        direction="row"
        spacing={2}
        alignContent="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box gap="16px" width="100%">
          <Typography
            color="#343948"
            fontWeight={600}
            fontSize={{ xs: "16px", sm: "18px" }}
            lineHeight={{ xs: "20px", sm: "22px" }}
          >
            {productName}
          </Typography>
          <Typography
            color="#343948"
            fontWeight={400}
            fontSize={{ xs: "14px", sm: "16px" }}
            lineHeight={{ xs: "18px", sm: "20px" }}
          >
            {productDescription}
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            alignContent="center"
            justifyContent="space-between"
            width="100%"
          >
            <Stack justifyContent="center">
              <Typography
                fontWeight={700}
                sx={{
                  fontSize: "20px",
                  lineHeight: "24px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {NumberFunctions.formatMoneyDefault(value)}
                <Typography
                  fontWeight={400}
                  color={red[500]}
                  sx={{
                    fontSize: "14px",
                    lineHeight: "18px",
                    textDecoration: "line-through",
                    pl: 1,
                  }}
                >
                  {NumberFunctions.formatMoneyDefault(59)}
                </Typography>
              </Typography>
            </Stack>
            <Stack
              direction="column"
              spacing={1}
              alignContent="end"
              alignItems="end"
            >
              <Avatar
                sx={{
                  bgcolor: "#ffffff",
                  border: "1px solid #DCDDDE",
                  color: "#000000",
                  fontWeight: 700,
                  fontSize: "20px",
                  lineHeight: "24px",
                  width: 40,
                  height: 40,
                  borderRadius: "16px",
                }}
              >
                1
              </Avatar>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  )
}

export default DetailProductItem8
